import { Component } from 'react'
import styled from 'styled-components'
import Media from 'components/utils/Media'

import giftVoucherSample from 'assets/images/voucher-redemption@3x.png' // eslint-disable-line
import headerBackgroundImage from 'assets/images/hero-voucher-redeem.jpg' // eslint-disable-line

import ButtonLink from '../../../components/display/ButtonLink'

import BrandMapIcon from '../../../components/icons/brand/BrandMap'
import BrandTelescopeIcon from '../../../components/icons/brand/BrandTelescope'
import BrandVoucherIcon from '../../../components/icons/brand/BrandVoucher'

const PlainInfoWell = styled.section`
  position: relative;
  background-color: ${({ theme }) => theme.colors.grey};
  padding: 45px;
  margin-bottom: 40px;

  h4 {
    margin-bottom: 20px;
  }
`

const IconWrap = styled.div`
  text-align: center;
  width: 76px;
  margin-right: 40px;
  margin-bottom: 40px;

  svg {
    display: inline-block;
    width: 100%;
  }

  ${({ voucher }) =>
    voucher &&
    `
    svg {
      max-width: 100px;
    }
  `}
`

const Step = styled.div`
  display: flex;
  text-align: left;
  margin-bottom: 80px;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`

const StepDesc = styled.div`
  flex: 1;
  max-width: 600px;
`

const OldVoucherInfo = () => (
  <PlainInfoWell>
    <h4>Got one of our older-style gift vouchers?</h4>
    <p>
      If you have one of our older-style vouchers with a 4-digit voucher number
      instead of an 8-digit voucher code, email us at{' '}
      <a
        href="mailto:support@riparide.com"
        target="_blank"
        className="color-green"
        rel="noopener noreferrer"
      >
        support@riparide.com
      </a>{' '}
      and we’ll help you redeem it.
    </p>
  </PlainInfoWell>
)

class VoucherRedeem extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div>
        <div
          className="container-fluid hero-container"
          style={{ backgroundImage: `url(${headerBackgroundImage})` }}
        >
          <div className="hero-image vignette" />
          <div className="hero-image-overlay image-overlay">
            <div className="container">
              <h1>
                Redeem{' '}
                <span style={{ fontWeight: 'normal' }}>a Gift Voucher</span>
              </h1>
            </div>
          </div>
        </div>

        <section className="content-section">
          <div className="container">
            <div className="col-xs-12 col-md-4 col-md-push-8">
              <Media query="(min-width: 992px)">
                <OldVoucherInfo />
              </Media>
            </div>

            <div className="col-xs-12 col-md-8 col-md-pull-4">
              <p className="lead" style={{ marginBottom: 60 }}>
                If you’ve got a Riparide Gift Voucher, follow these steps to
                redeem it. If you need any help, give us a shout at{' '}
                <a
                  href="mailto:support@riparide.com"
                  target="_blank"
                  className="color-green"
                  rel="noopener noreferrer"
                >
                  support@riparide.com
                </a>
                .
              </p>

              <Step>
                <IconWrap>
                  <BrandTelescopeIcon />
                </IconWrap>
                <StepDesc>
                  <h3>Find a Listing or Story</h3>
                  <p>
                    Browse through our amazing listings and stories to find one
                    you love. You can also search for a specific listing or
                    story by title using the search field at the top left.
                  </p>
                </StepDesc>
              </Step>
              <Step>
                <IconWrap>
                  <BrandMapIcon />
                </IconWrap>
                <StepDesc>
                  <h3>Make a Booking</h3>
                  <p>
                    Add your travel dates, number of people and make a booking
                    request as per usual. You’ll be able to add your voucher at
                    the next step.
                  </p>
                </StepDesc>
              </Step>
              <Step>
                <IconWrap voucher>
                  <BrandVoucherIcon />
                </IconWrap>
                <StepDesc>
                  <h3>Apply the Voucher</h3>
                  <p>
                    When you get to the payment page, you’ll see an option to
                    add a gift voucher. Enter the voucher code and VOILA, the
                    voucher is now applied to your booking.
                  </p>
                </StepDesc>
              </Step>

              <Step>
                <IconWrap />
                <StepDesc>
                  <div style={{ textAlign: 'center' }}>
                    <ButtonLink inline href="/listings">
                      Use Your Voucher Now
                    </ButtonLink>
                  </div>
                </StepDesc>
              </Step>
            </div>
          </div>
        </section>

        <Media query="(max-width: 991px)">
          <div className="container">
            <OldVoucherInfo />
          </div>
        </Media>
      </div>
    )
  }
}

export default VoucherRedeem
